<div class="locality-container" *ngIf="!isLoadingLabels && !isLoadingLocations && !isLoadingSites">
	<div class="search" *ngIf="customInterface.id == undefined">
		<cpi-input-with-autocomplete
			[availableOptions]="listLocationsIAC"
			[minInputLength]="3"
			[placeholder]="labels.lbl_geral_pesquisar + '. ' + labels.lbl_iac_min_char_search.replace('$__$', '3')"
			[cleanValues]="clearValuesLocation"
			[keepValue]="false"
			(onValueChange)="getLocation($event)"
			*ngIf="!isLoadingLocations">
		</cpi-input-with-autocomplete>

		<cpi-msp-table
			[header]="searchHeader"
			[body]="locationsList"
			[height]="'55dvh'"
			[itemPadding]="'1%'"
			[labels]="labels"
			[sortDown]="true"
			(getSort)="sort($event['sortDown'])"
			(getSelectedItem)="getLocation($event[0]['id'])">
		</cpi-msp-table>

		<div class="button-container">
			<div class="button" (click)="clearInputs(true)">{{ labels.lbl_geral_nova_localidade }}</div>
		</div>
	</div>

	<ng-container *ngIf="customInterface.id != undefined">
		<div class="header-wrap">
			<span class="tab selected">{{ labels.lbl_geral_localidades }}</span>
		</div>

		<div class="body-wrap">
			<!-- Form de criação/atualização de localidades -->
			<div class="dotted-input-container">
				<span>{{ labels.lbl_geral_localidade }} *</span>
				<input type="text" [value]="customInterface.location" (input)="customInterface.location = $event.target.value" />
			</div>

			<div class="dotted-input-container">
				<span>{{ labels.lbl_geral_site }} *</span>
				<cpi-input-with-autocomplete
					[availableOptions]="listSitesIAC"
					[minInputLength]="0"
					[setInputText]="customInterface.name_site"
					[setValue]="customInterface.name_site"
					[placeholder]="labels.lbl_selecione_site"
					[cleanValues]="clearValuesSite"
					(onValueChange)="getSite($event)"
					*ngIf="!isLoadingSites">
				</cpi-input-with-autocomplete>
			</div>

			<div class="dotted-input-container">
				<span>{{ labels.lbl_geral_sala }}</span>
				<input type="text" [value]="customInterface.room" (input)="customInterface.room = $event.target.value" />
			</div>

			<div class="dotted-input-container">
				<span>{{ labels.lbl_geral_andar }}</span>
				<input type="text" [value]="customInterface.floor" (input)="customInterface.floor = $event.target.value" />
			</div>

			<div class="dotted-input-container">
				<span> {{ labels.lbl_geral_cidade }} </span>
				<input type="text" [value]="customInterface.city" (input)="customInterface.city = $event.target.value" />
			</div>

			<div class="dotted-input-container">
				<span> {{ labels.lbl_asset_inventario_endereco }} </span>
				<input id="address" name="address" type="text" [(ngModel)]="customInterface.address" />
			</div>

			<div class="dotted-input-container">
				<span> {{ labels.lbl_asset_inventario_estado }} </span>
				<input type="text" [value]="customInterface.state" (input)="customInterface.state = $event.target.value" />
			</div>

			<div class="dotted-input-container">
				<span> {{ labels.lbl_geral_observacoes }} </span>
				<input type="text" [value]="customInterface.info" (input)="customInterface.info = $event.target.value" />
			</div>

			<div class="dotted-input-container">
				<span>{{ labels.lbl_local_estoque }}</span>
				<input type="checkbox" [(ngModel)]="customInterface.is_stock" />
			</div>

			<div class="button-container">
				<div class="button" (click)="clearInputs(false)">{{ labels.lbl_geral_voltar }}</div>
				<div class="button" (click)="clearInputs(true)">{{ labels.lbl_geral_nova_localidade }}</div>
				<!-- <div class="button" (click)="clearInputs(customInterface)"> {{labels.lbl_geral_location_limpar_campos}}</div> -->
				<div
					class="button"
					[ngClass]="{ disabled: isUpdating || isChangingState }"
					*ngIf="this.isButtonVisible === 1"
					(click)="deleteLocality(customInterface.id)">
					{{ labels.lbl_geral_desativar }}
					<cpi-dot-bounce-loading-effect [color]="'var(--const-white)'" *ngIf="isChangingState"></cpi-dot-bounce-loading-effect>
				</div>
				<div
					class="button"
					[ngClass]="{ disabled: isUpdating || isChangingState }"
					*ngIf="this.isButtonVisible === 0"
					(click)="activeLocality(customInterface.id)">
					{{ labels.lbl_geral_location_ativar }}
					<cpi-dot-bounce-loading-effect [color]="'var(--const-white)'" *ngIf="isChangingState"></cpi-dot-bounce-loading-effect>
				</div>
				<div class="button" [ngClass]="{ disabled: isUpdating || isChangingState }" (click)="validateForm()">
					{{ labels.lbl_geral_salvar }}
					<cpi-dot-bounce-loading-effect [color]="'var(--const-white)'" *ngIf="isUpdating"></cpi-dot-bounce-loading-effect>
				</div>
			</div>
		</div>
	</ng-container>
</div>

<cpi-dot-bounce-loading-effect
	*ngIf="isLoadingLabels || isLoadingLocations || isLoadingSites"
	[color]="'var(--primary-color-1)'"></cpi-dot-bounce-loading-effect>
